document.querySelector('a[href*="#"]') &&
  Array.from(document.querySelectorAll('a[href*="#"]')).forEach((each) =>
    each.addEventListener("click", function (e) {
      e.preventDefault();
      smoothScroll(this.getAttribute("href"), 1000, 60);
    })
  );

document.querySelector(".rg-auto-gallery") &&
  document.querySelectorAll(".rg-auto-gallery").forEach((item) => {
    new Splide(item, {
      type: "loop",
      focus: "center",
      perPage: 2,
      arrows: false,
      pagination: false,
      gap: "1rem",
      breakpoints: {
        989: {
          perPage: 1.5,
          gap: "0.85rem",
        },
      },
    }).mount(window.splide.Extensions);
  });

document.querySelector(".feature-columns--slider") &&
  Array.from(document.querySelectorAll(".feature-columns--slider")).forEach(
    (item) => {
      const splide = new Splide(item, {
        arrows: true,
        pagination: true,
        gap: "1rem",
        perMove: 1,
        breakpoints: {
          989: {
            type: "loop",
            perPage: 2.75,
            gap: "0.75rem",
            focus: "center",
          },
          749: {
            perPage: 1,
            gap: "0.75rem",
            focus: "center",
          },
        },
      });

      splide.on("mounted", function () {
        if (
          splide.root
            .querySelector(".splide__arrows")
            .querySelectorAll("[disabled]").length > 1
        )
          splide.root
            .querySelector(".splide__arrows")
            .classList.add("invisible");
      });

      splide.mount();
    }
  );

document.querySelector(".rgeek-gallery--full") &&
  document.querySelectorAll(".rgeek-gallery--full").forEach((item) => {
    new Splide(item, {
      type: "loop",
      autoplay: false,
      perPage: 4,
      // perMove: 1,
      arrows: false,
      pagination: false,
      padding: "55px",
      gap: "1rem",
      //focus: 'center',
      width: "1400px",
      autoHeight: false,
      interval: 3000,
      breakpoints: {
        989: {
          perPage: 2.5,
          //gap: '1rem',
          padding: "25px",
          autoWidth: true,
          pagination: true,
        },
        749: {
          perPage: 1,
          focus: 0,
          padding: 0,
          autoWidth: true,
          pagination: true,
          //gap: '1rem',
          padding: { left: "25px", right: "100px" },
        },
      },
    }).mount(window.splide.Extensions);
  });

document.querySelector(".rgeek-haphazard-gallery") &&
  document.querySelectorAll(".rgeek-haphazard-gallery").forEach((item) => {
    new Splide(item, {
      type: "loop",
      autoplay: true,
      perPage: 4,
      perMove: 1,
      arrows: false,
      pagination: true,
      gap: "1rem",
      focus: "center",
      interval: 3000,
      breakpoints: {
        989: {
          perPage: 3,
          gap: "1rem",
        },
        749: {
          perPage: 1.3,
          gap: "1rem",
        },
      },
    }).mount();
  });

document.querySelector(".rgeek-gallery") &&
  document.querySelectorAll(".rgeek-gallery").forEach((item) => {
    new Splide(item, {
      type: "loop",
      autoplay: true,
      perPage: 3,
      perMove: 1,
      arrows: false,
      pagination: true,
      gap: "1rem",
      focus: "center",
      interval: 3000,
      breakpoints: {
        989: {
          perPage: 2,
          gap: "1rem",
        },
        749: {
          perPage: 1,
          gap: "1rem",
        },
      },
    }).mount();
  });

document.querySelector(".rg-testimonials-slider") &&
  document.querySelectorAll(".rg-testimonials-slider").forEach((item) => {
    new Splide(item, {
      type: "loop",
      focus: 0,
      perPage: 4,
      perMove: 1,
      arrows: true,
      pagination: true,
      gap: "25px",
      breakpoints: {
        989: {
          perPage: 3,
          gap: "0.85rem",
        },
        749: {
          focus: "center",
          // width: '80vw',
          gap: "0.85rem",
          perPage: 1.5,
        },
      },
    }).mount();
  });

document.querySelector(".rg-banners-slider") &&
  document.querySelectorAll(".rg-banners-slider").forEach((item) => {
    new Splide(item, {
      type: "loop",
      focus: "center",
      perPage: 1.5,
      perMove: 1,
      arrows: true,
      pagination: true,
      gap: "1rem",
      breakpoints: {
        989: {
          gap: "0.85rem",
        },
        749: {
          perPage: 1,
          gap: "0.85rem",
        },
      },
    }).mount();
  });

document.querySelector(".rgeek-gallery--full") &&
  document.querySelectorAll(".rgeek-gallery--full").forEach((item) => {
    const cursor = document.querySelector(".cursor");

    if (!cursor) return;

    item.addEventListener("mousemove", function (e) {
      var x = e.clientX;
      var y = e.clientY;
      cursor.style.opacity = 1;
      cursor.style.transform = `translate3d(calc(${e.clientX}px - 50%), calc(${e.clientY}px - 50%), 0)`;
      //     cursor.style.left = e.clientX + 'px';
      //     cursor.style.top = e.clientY + 'px';
    });

    item.addEventListener("mouseleave", () => {
        cursor.style.opacity = 0;
      });
  });

function smoothScroll(targetEl, duration, exact) {
  let target = document.querySelector(targetEl);
  let targetPosition = target.getBoundingClientRect().top - exact;
  let startPosition = window.scrollY;
  let startTime = null;

  const ease = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return (c / 2) * t * t + b;
    t--;
    return (-c / 2) * (t * (t - 2) - 1) + b;
  };

  const animation = function (currentTime) {
    if (startTime === null) startTime = currentTime;
    const timeElapsed = currentTime - startTime;
    const run = ease(timeElapsed, startPosition, targetPosition, duration);
    window.scrollTo(0, run);
    if (timeElapsed < duration) requestAnimationFrame(animation);
  };

  requestAnimationFrame(animation);
}
